"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeSyncStatus = void 0;
var EmployeeSyncStatus;
(function (EmployeeSyncStatus) {
    EmployeeSyncStatus["PENDING"] = "PENDING";
    EmployeeSyncStatus["SYNCING"] = "SYNCING";
    EmployeeSyncStatus["SYNCED"] = "SYNCED";
    EmployeeSyncStatus["FAILED"] = "FAILED";
})(EmployeeSyncStatus || (exports.EmployeeSyncStatus = EmployeeSyncStatus = {}));
